// Tagging a new article (TAGS.md §3), the "DeepSeek" path through the text model, plus the source from the URL.
// Only one device needs to tag an article; the phones also tag anything left untagged.
import { library } from "../model/library";
import { textModel } from "../models";
import { settings } from "../settings";
import { TextClient, unavailable } from "../levels/textClient";
import { isoNow } from "../util";
import { autoTags, needsTagging, openrouterMessages, parseOpenrouter, sourceTag } from "./tags";
import { taxonomy } from "./taxonomyStore";

export async function tagArticle(id: string): Promise<void> {
  const a = library.get(id);
  if (!a || a.status !== "ready" || !settings.autoTag || !needsTagging(a.meta.tags, taxonomy.list)) return;
  const t = taxonomy.list;
  const src = sourceTag(a.meta.sourceURL, a.meta.siteName, (a.meta.images ?? []).map((i) => i.src));
  const model = textModel();
  let decision = null;
  if (!unavailable(model)) {
    try {
      const reply = await new TextClient(model).chat({ messages: openrouterMessages(a.meta.title ?? "", a.meta.siteName ?? "", a.meta.author ?? "",
        a.meta.text ?? a.meta.sharedText ?? "", t), response_format: { type: "json_object" }, temperature: 0, max_tokens: 300,
        reasoning: { enabled: false }, usage: { include: true } });
      decision = parseOpenrouter(reply, t);
    } catch { decision = null; }
  }
  if (!decision) return; // untagged: try again later (a phone will, too)
  library.editMeta(id, (m) => {
    m.tags = { ...(m.tags ?? {}), auto: autoTags(decision, src), by: "deepseek", at: isoNow(), version: t.version };
  });
}
